import { render } from "./AddCaptioningModal.vue?vue&type=template&id=2e06edf9"
import script from "./AddCaptioningModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCaptioningModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/AddCaptioningModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e06edf9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e06edf9', __exports__)) {
    api.reload('2e06edf9', __exports__)
  }
  
  module.hot.accept("./AddCaptioningModal.vue?vue&type=template&id=2e06edf9", () => {
    api.rerender('2e06edf9', render)
  })

}


export default __exports__